import api from "../api/axios";

const ChequeService = {
  getCheques: async (status, type, startDate, endDate) => {
    const response = await api.get("/Cheque", { params: { status, type, startDate, endDate } });
    return response.data;
  },
  endorseCheque: async (data) => {
    const response = await api.post("/Cheque/endorse", data);
    return response.data;
  },
  updateStatus: async (data) => {
    const response = await api.post("/Cheque/update-status", data);
    return response.data;
  },
  createCheque: async (data) => {
    const response = await api.post("/Cheque", data);
    return response.data;
  },
  updateCheque: async (data) => {
    const response = await api.post("/Cheque/update", data);
    return response.data;
  }
};

export default ChequeService;
